<mat-nav-list shadow>
  <mat-list-item *ngFor="let link of links" 
                 [routerLink]="link.target" 
                 routerLinkActive="active-link">
     <mat-icon matListIcon>{{link.icon}}</mat-icon>
     <div mat-line>{{link.description}}</div>
  </mat-list-item>

  <mat-divider></mat-divider>

  <mat-list-item (click)="logOut()" class="logout-item">
     <mat-icon matListIcon>logout</mat-icon>
     <div mat-line>Logout</div>
  </mat-list-item>
</mat-nav-list>